import { CloseCircle } from 'iconsax-react';
import { useTiclickTableContext } from './context/ticlick-table-context-hook';
import { useTableViewHelpers } from '@design-system/molecules/ticlick-table/hooks/use-table-view-helpers';
import { useTableStates } from './hooks/use-table-states';

const DuplicatedFilter = () => {
  const { table } = useTiclickTableContext();
  const { tableFilters } = useTableStates();
  const { clearMultipleFacets } = useTableViewHelpers();

  if (!tableFilters?.staticFilters?.find((f) => f.field === 'term'))
    return null;

  const leadsData = table.options.meta?.queryData?.data;

  return (
    <span
      className='px-3 h-full py-2 text-gray-800 flex text-sm gap-2 rounded-xl items-center border border-pale-border cursor-pointer'
      onClick={() => clearMultipleFacets(['term', 'excluded_lead_ids'])}
    >
      <CloseCircle
        className='cursor-pointer'
        size={16}
      />
      Duplicated ({leadsData?.results.length || 0})
    </span>
  );
};

export function CurrentFilters() {
  return (
    <>
      <DuplicatedFilter />
    </>
  );
}
